import App from 'app/app.js';
import 'app/service/RouterService.js';
import { sanitizeInput } from '@app/utils/sanitize';

var lifetouchCode;

function LtLifetouchCodeFormCtrl(
  $scope,
  $rootScope,
  $routeParams,
  $window,
  $filter,
  $location,
  RouterService,
  MessageStore,
  JobStore,
  ContentStore,
  ShoppingCartStore,
  ErrorLogService,
  SubjectStore,
  OrderFormService,
  BlockService,
  RedirectionService,
  GradeService,
  ValidationService,
  JobCleanUpService,
  AnalyticsService,
  PortraitIdFormatterService
) {
  var ACCESS_CODE_LENGTH = 4;

  var that = this;
  this.lifetouchCode = $scope.lifetouchCode;
  this.portraitId = '';
  this.pictureDayId = '';
  this.accessCode = sanitizeInput($routeParams.accessCode, '');
  this.subjectFirstName = sanitizeInput($location.search().firstName);
  this.subjectLastName = sanitizeInput($location.search().lastName);
  this.subjectGrade = $location.search().gradeCode;
  this.subjectTeacherName = null;
  this.subjectRelationship = null;
  this.relationshipDisclaimer = false;
  this.grades = GradeService.getGrades();
  this.dontKnowTeacherName = false;
  this.isPictureDayIdInValid = false;

  this.getAdobeFormId = function () {
    return this.isPortraitIdEntered()
      ? AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_PORTRAITID_DETAIL
      : AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_PICTUREID_DETAIL;
  };

  this.init = function () {
    var self = this;
    this.subjectFirstNameInvalid = false;
    this.subjectLastNameInvalid = false;
    this.subjectGradeInvalid = false;
    this.accessCodeInvalid = false;
    this.portraitIdInvalid = false;
    this.pictureDayIdInvalid = false;
    this.subjectRelationshipInvalid = false;
    this.relationshipDisclaimer = false;
    this.subjectRelationshipDisclaimerSelected = false;
    this.showGrade = true;
    this.isPictureDayIdInValid = false;

    var unwatchLifetouchCode = $scope.$watch(
        'lifetouchCode',
        function (lifetouchCode) {
          this.lifetouchCode = lifetouchCode;
        }.bind(this)
      ),
      unwatchPortraitId = $scope.$watch(
        'portraitId',
        function (portraitId) {
          this.portraitId = portraitId;
        }.bind(this)
      ),
      unwatchPictureDayId = $scope.$watch(
        'pictureDayId',
        function (pictureDayId) {
          this.pictureDayId = pictureDayId;
        }.bind(this)
      ),
      unwatchSubjectRelationship = $scope.$watch(
        'subjectRelationship',
        function (subjectRelationship) {
          this.subjectRelationship = subjectRelationship;
        }.bind(this)
      ),
      unwatchJobLoadFailedAction = $rootScope.$on(
        'jobLoadFailed',
        function () {
          self.setInvalid();
        }.bind(this)
      );

    $scope.$on('$destroy', function () {
      unwatchLifetouchCode();
      unwatchPortraitId();
      unwatchPictureDayId();
      unwatchSubjectRelationship();
      unwatchJobLoadFailedAction();
    });
    this.enableRelationshipDisclaimer = false;
  };

  this.setInvalid = function () {
    if (this.isPortraitIdEntered()) {
      this.subjectFirstNameInvalid = true;
      this.subjectLastNameInvalid = true;
      this.subjectGradeInvalid = true;
      this.accessCodeInvalid = true;
    } else {
      this.isPictureDayIdInValid = true;
      this.pictureDayIdInvalid = true;
    }
    this.portraitIdInvalid = true;
  };

  this.unCheck = function () {
    this.relationshipDisclaimer = false;
    this.subjectRelationshipDisclaimerSelected = false;
  };

  this.askForSubjectTeacherName = function () {
    // TODO: temp solution, see https://lifetouchlnss.atlassian.net/browse/MLC-10529
    OrderFormService.setTeacherNameStatus(true);
    return true;

    if (JobStore.getSubProgramName()) {
      return JobStore.getSubProgramName().toUpperCase() === 'CLASSROOM GROUPS';
    }
    return false;
  };

  this.resetTeacher = function (teacherName) {
    this.subjectTeacherName = '';
    ValidationService.resetErrors(teacherName);
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };

  this.getPlaceholderByCountry = function (key) {
    key = ContentStore.appendCountryCode(key);
    return this.getPlaceholder(key);
  };

  this.onContinue = function () {
    if (!JobCleanUpService.cleanUpAndCanAddMoreJobs()) {
      return;
    }

    if (!this.isLifetouchCodeFormValid()) {
      AnalyticsService.addAdobeFormErrorEvent(
        this.getAdobeFormId(),
        AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.INVALID_FORM
      );
      return;
    }

    const formData = {};
    formData.subjectLastName = this.formatInputTextFields(this.subjectLastName);
    formData.subjectGrade = this.formatInputTextFields(this.subjectGrade);
    formData.subjectRelationship = this.subjectRelationship;
    if (this.isPortraitIdEntered()) {
      formData.portraitId = this.formatInputTextFields(this.portraitId);
      formData.accessCode = this.formatInputTextFields(this.accessCode);
      this.submitLifetouchCodeForm(formData);
    } else if (this.isPictureDayIdEntered()) {
      formData.pictureDayId = this.formatInputTextFields(this.pictureDayId);
      formData.subjectFirstName = this.formatInputTextFields(this.subjectFirstName);
      formData.subjectTeacherName = this.formatInputTextFields(this.subjectTeacherName);
      formData.dontKnowTeacherName = this.dontKnowTeacherName;
      if (!this.askForSubjectTeacherName()) {
        formData.dontKnowTeacherName = true;
      }
      this.submitLifetouchCodeForm(formData);
    } else {
      ErrorLogService(new Error('Illegal state: Expected either portraitId or pictureDayId code to be entered'));
    }
  };

  this.submitLifetouchCodeForm = function (formData) {
    BlockService.blockUI();
    MessageStore.clear();
    JobStore.loadJob(formData, false)
      .then(
        function (data) {
          BlockService.unblockUI();
          if (!data || (!!data.data && !data.data.success) || !JobStore.isJobLoaded()) {
            this.correctionRequired = true;
            if (this.accessedViaSmartLink) {
              StatsdService.logSmartLinkFailure(RouterService.getSource());
            }
            // add failure needs to flip based on pictureId vs portraitId
            AnalyticsService.addAdobeFormErrorEvent(
              this.getAdobeFormId(),
              AnalyticsService.ADOBE_ERROR_DESCRIPTIONS.INVALID_INVALID_PDI
            );
            return;
          }
          this.correctionRequired = false;

          AnalyticsService.addAdobeFormSuccessEvent(this.getAdobeFormId());
          var activeJob = JobStore.getJob();
          var subject = ShoppingCartStore.getCurrentSubject();
          $rootScope.openCopyOrderModalOnSubjectLoad = true;

          if (activeJob.spectrumEnabled && activeJob.sellingMethod === 'SPEC') {
            if (activeJob.orderType === 'PAYMENT' && subject.packages.length === 0) {
              this.loadSpecDialog();
            } else {
              this.goToNext();
            }
          } else if (!activeJob.spectrumEnabled || JobStore.isSpectrumPayOnly()) {
            this.goToPayOnly(formData);
          } else {
            subject.subjectRelationship = formData.subjectRelationship;
            subject.subjectTeacherName = formData.subjectTeacherName;
            this.goToNext();
          }
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.unblockUI();
      });
  };

  this.goToPayOnly = function (formData) {
    if (JobStore.isPayOnly()) {
      var activeJob = JobStore.getJob();
      var currentSubject = ShoppingCartStore.getCurrentSubject();
      if (!!currentSubject) {
        currentSubject.subjectFirstName = formData.subjectFirstName;
        currentSubject.subjectLastName = formData.subjectLastName;
        currentSubject.subjectGrade = formData.subjectGrade;
        currentSubject.subjectRelationship = formData.subjectRelationship;
        currentSubject.subjectTeacherName = formData.subjectTeacherName;
        currentSubject.dontKnowTeacherName = formData.dontKnowTeacherName;
        currentSubject.allowPersonalizationNamePrefill = Boolean(
          currentSubject.subjectFirstName &&
          !SubjectStore.isGeneratedFirstNamePlaceholder(currentSubject.subjectFirstName)
        );
        SubjectStore.addOrUpdateSubjectByJob(activeJob, currentSubject);
        ShoppingCartStore.confirmSubjectAccount();
        RouterService.goToPayOnly();
      }
    }
  };

  this.goToNext = function () {
    if (JobStore.isPreOrder()) {
      this.submitPictureDayIdForm();
    } else {
      var activeJob = JobStore.getJob();
      this.subject = ShoppingCartStore.getCurrentSubject();
      this.subject.allowPersonalizationNamePrefill = Boolean(
        this.subject.subjectFirstName && !SubjectStore.isGeneratedFirstNamePlaceholder(this.subject.subjectFirstName)
      );
      SubjectStore.addOrUpdateSubjectByJob(activeJob, this.subject);
      ShoppingCartStore.confirmSubjectAccount();
      RouterService.goToMyProofs();
    }
  };

  this.submitPictureDayIdForm = function () {
    var currentSubject = ShoppingCartStore.getCurrentSubject();
    if (!!currentSubject) {
      currentSubject.subjectFirstName = this.subjectFirstName;
      currentSubject.subjectLastName = this.subjectLastName;
      currentSubject.subjectGrade = this.subjectGrade;
      currentSubject.subjectRelationship = this.subjectRelationship;
      currentSubject.allowPersonalizationNamePrefill = Boolean(
        currentSubject.subjectFirstName &&
        !SubjectStore.isGeneratedFirstNamePlaceholder(currentSubject.subjectFirstName)
      );
    }
    if (RouterService.isSflyMobile()) {
      try {
        this.sendPictureDayToApp(
          JobStore.getJob().jobKey,
          this.subjectFirstName,
          this.subjectLastName,
          this.subjectGrade
        );
      } catch (error) {
        error.message = 'Error while attempting to send Picture Day to SFLY_MOBILE: ' + error.message;
        ErrorLogService(error);
      }
    }
    var activeJob = JobStore.getJob();
    SubjectStore.addOrUpdateSubjectByJob(activeJob, currentSubject);
    ShoppingCartStore.confirmSubjectAccount();
    RedirectionService.routeNext($routeParams);
  };

  this.sendPictureDayToApp = function (pictureDayId, firstName, lastName, grade) {
    var params = { id: pictureDayId, firstName: firstName, lastName: lastName, grade: grade };

    // Trying to call for iOS native method.
    if (!!$window.webkit) {
      if (!!$window.webkit.messageHandlers.savePictureDayId) {
        $window.webkit.messageHandlers.savePictureDayId.postMessage(JSON.stringify(params));
      }
    }

    // Trying to call for Android native method.
    if (!!$window.appInterface) {
      $window.appInterface.savePictureDayId(JSON.stringify(params));
    }
  };

  this.formatInputTextFields = function (text) {
    return (text && text.trim().toUpperCase()) || '';
  };

  this.isPortraitIdValid = function () {
    return !!this.portraitId && this.portraitId.length > 0;
  };

  this.toggleDisclaimer = function (self) {
    this.subjectRelationshipDisclaimerSelected =
      self.currentTarget.firstElementChild.id === 'relationshipDisclaimer' &&
      self.currentTarget.firstElementChild.checked === true;
  };

  this.getRelationshipDisclaimer = function () {
    var disclaimer;
    if (this.subjectRelationship === 'ParentGuardian') {
      disclaimer = this.getPlaceholderByCountry('PICTURE_DAY_PARENT_GUARDIAN_DISCLAIMER');
    } else {
      disclaimer = this.getPlaceholderByCountry('PICTURE_DAY_GRANDPARENT_OTHER_DISCLAIMER');
    }
    return disclaimer;
  };

  this.setRelationshipDisclaimer = function () {
    this.enableRelationshipDisclaimer = this.subjectRelationship;
    if (!Boolean(this.enableRelationshipDisclaimer)) {
      this.unCheck();
    }
  };

  this.isAccessCodeValid = function () {
    return !!this.accessCode && this.accessCode.trim().length === ACCESS_CODE_LENGTH;
  };

  this.isPortraitIdEntered = function () {
    return OrderFormService.getCurrentFlow().includes('portraitIdForm');
  };

  this.isPictureDayIdEntered = function () {
    return OrderFormService.getCurrentFlow().includes('pictureDayIdForm');
  };

  this.isSubjectFirstNameValid = function () {
    if (this.isPictureDayIdFlow()) {
      return !!this.subjectFirstName && this.subjectFirstName.length > 0;
    }
    return true;
  };

  this.isSubjectLastNameValid = function () {
    return !!this.subjectLastName && this.subjectLastName.length > 0;
  };

  this.isSubjectGradeValid = function () {
    return this.showGrade ? !!this.subjectGrade && this.subjectGrade.length > 0 : true;
  };

  this.isSubjectRelationshipValid = function () {
    return !!this.subjectRelationship && this.subjectRelationship.length > 0;
  };

  this.isSubjectTeacherNameValid = function () {
    return this.dontKnowTeacherName == true || (this.subjectTeacherName ? this.subjectTeacherName.length > 0 : false);
  };

  this.checkAccessCode = function () {
    this.accessCode = PortraitIdFormatterService.checkAccessCode(this.accessCode);
  };

  this.validateInput = function (inputName, isCorrection) {
    if (isCorrection && !this.correctionRequired) {
      return;
    }
    if (isCorrection && this.correctionRequired) {
      this.correctionRequired = false;
    }
    if (inputName === 'ID' || isCorrection) {
      this.portraitIdInvalid = !this.isPortraitIdValid();
    }
    if (inputName === 'accessCode' || isCorrection) {
      this.accessCodeInvalid = !this.isAccessCodeValid();
    }
    if (inputName === 'subjectFirstName' || isCorrection) {
      this.subjectFirstNameInvalid = !this.isSubjectFirstNameValid();
    }
    if (inputName === 'subjectLastName' || isCorrection) {
      this.subjectLastNameInvalid = !this.isSubjectLastNameValid();
    }
    if (inputName === 'subjectGrade' || isCorrection) {
      this.subjectGradeInvalid = !this.isSubjectGradeValid();
    }
    if (inputName === 'subjectRelationship' || isCorrection) {
      this.subjectRelationshipInvalid = !this.isSubjectRelationshipValid();
    }
  };

  this.disableShopNowButton = function () {
    if (this.isPortraitIdEntered()) {
      return this.correctionRequired || !this.isLifetouchCodeFormValid() || !this.subjectRelationshipDisclaimerSelected;
    }
    if (this.isPictureDayIdEntered()) {
      return !(
        this.isSubjectFirstNameValid() &&
        this.isSubjectLastNameValid() &&
        this.isSubjectGradeValid() &&
        this.isSubjectRelationshipValid() &&
        this.subjectRelationshipDisclaimerSelected &&
        !this.isPictureDayIdInValid &&
        this.isSubjectTeacherNameValid()
      );
    }
    return true;
  };

  this.isLifetouchCodeFormValid = function () {
    if (this.isPortraitIdEntered()) {
      return (
        this.isPortraitIdValid() &&
        this.isAccessCodeValid() &&
        this.isSubjectLastNameValid() &&
        this.isSubjectGradeValid() &&
        this.isSubjectRelationshipValid()
      );
    }
    if (this.isPictureDayIdEntered()) {
      return (
        this.isSubjectFirstNameValid() &&
        this.isSubjectLastNameValid() &&
        this.isSubjectGradeValid() &&
        this.isSubjectRelationshipValid()
      );
    }
    return false;
  };

  this.resetFormValues = function () {
    this.portraitId = null;
    this.accessCode = '';
    this.subjectFirstName = null;
    this.subjectLastName = null;
    this.subjectGrade = '';
    this.subjectRelationship = null;
    this.subjectTeacherName = null;
    this.dontKnowTeacherName = false;

    this.subjectFirstNameInvalid = false;
    this.subjectLastNameInvalid = false;
    this.subjectGradeInvalid = false;
    this.accessCodeInvalid = false;
    this.portraitIdInvalid = false;
    this.pictureDayIdInvalid = false;
    this.subjectRelationshipInvalid = false;
    this.isPictureDayIdInValid = false;

    this.enableRelationshipDisclaimer = false;

    this.resetLifetouchCode();
    MessageStore.clear();
  };

  this.open = function () {
    this.visible = true;
  };

  this.close = function () {
    this.visible = false;
  };

  this.isLifetouchCodeFlow = function () {
    return OrderFormService.getCurrentFlow().includes('activeLTCodeTab');
  };

  this.isPortraitIdFlow = function () {
    return OrderFormService.getCurrentFlow().includes('portraitIdForm');
  };

  this.isPictureDayIdFlow = function () {
    return OrderFormService.getCurrentFlow().includes('pictureDayIdForm');
  };

  this.tryDifferentCode = function (form) {
    this.resetFormValues();
    this.unCheck();
    form.$setUntouched();
    form.$setPristine();
    OrderFormService.changeFlowToLifetouchCode();
    $location.path('/');
    $location.search({});
    this.correctionRequired = false;
  };

  this.resetLifetouchCode = function () {
    this.lifetouchCode = '';
  };

  this.getLifetouchCode = function () {
    this.lifetouchCode = $scope.lifetouchCode && $scope.lifetouchCode.length > 1 ? $scope.lifetouchCode : lifetouchCode;
    if (this.lifetouchCode && this.lifetouchCode.length > 1) {
      lifetouchCode = this.formatInputTextFields(this.lifetouchCode);
      if (this.portraitId !== lifetouchCode) {
        this.portraitIdInvalid = false;
      }
      this.portraitId = lifetouchCode;
      this.pictureDayId = lifetouchCode;
    }
    if (lifetouchCode && lifetouchCode.length === 8) {
      lifetouchCode = lifetouchCode.replace(/^([a-zA-Z0-9]{4})[- ]?([a-zA-Z0-9]{4}).*/, '$1-$2');
    }

    return lifetouchCode;
  };

  this.isUnderclass = function () {
    return JobStore.isUnderclass();
  };

  this.getTeacherPopoverText = function () {
    return ContentStore.getContent('PREPAY_STUDENT_INFO', ContentStore.appendCountryCode('PSI_TEACHER_DISCLAIMER'));
  };

  this.updateHomeFlexHeight = function () {
    var homeFlexElement = document.getElementById('home-flex');
    if (this.subjectRelationship) {
      homeFlexElement.style.height = '605px';
    }
  };
}

App.controller('LtLifetouchCodeFormCtrl', [
  '$scope',
  '$rootScope',
  '$routeParams',
  '$window',
  '$filter',
  '$location',
  'RouterService',
  'MessageStore',
  'JobStore',
  'ContentStore',
  'ShoppingCartStore',
  'ErrorLogService',
  'SubjectStore',
  'OrderFormService',
  'BlockService',
  'RedirectionService',
  'GradeService',
  'ValidationService',
  'JobCleanUpService',
  'AnalyticsService',
  'PortraitIdFormatterService',
  LtLifetouchCodeFormCtrl
]);
